import Vue from 'vue'
import axios from 'axios'
import Router from 'vue-router'
import Index from '@/page/index'
import Beginner from '@/page/Beginner'
import BeginnerDetail from '@/page/BeginnerDetail'
import Intermediate from '@/page/Intermediate'
import IntermediateDetail from '@/page/IntermediateDetail'
import Advanced from '@/page/Advanced'
import AdvancedDetail from '@/page/AdvancedDetail'
import Challenge from '@/page/Challenge'
import Book from '@/page/Book'
import BookDetail from '@/page/BookDetail'
import ChallengeLearn from '@/page/ChallengeLearn'
import ChallengeResult from '@/page/ChallengeResult'
import Sentences300 from '@/page/Sentences300'
import Sentences300Detail from '@/page/Sentences300Detail'


import Faq from '@/page/faq'
import guidance from '@/page/guidance'
import MyAccount from '@/page/myAccount'
import TermsAndCondition from '@/page/termsAndCondition'
import Login from '@/page/Login'
import otp from '@/page/otp'
import land from '@/page/land'

import Level from '@/page/level'
import LevelTest from '@/page/leveltest'
import BookDetail2 from '@/page/BookDetail2'

Vue.use(Router)

export default new Router({
  routes: [
    {
		path: '/',
		name: 'index',
		component: Index,
		meta: {
			title: ''
		},
      beforeEnter: async (to, from, next) => {
        //路由守卫逻辑
        //路由带号码 直接登录
        if (to.query.mobile) {
          const res = await axios.post('https://api.chineasier.com/api/user/fast_login', {
            mobile: to.query.mobile
          })
          if (res.data.code === 1){
            localStorage.setItem('token', res.data.data.userinfo.token)
            localStorage.setItem('mobile',res.data.data.userinfo.mobile)
            localStorage.setItem('avatar',res.data.data.userinfo.avatar)
          }
        }
        next()
      }
    },
    {
      path: '/Beginner',
      name: 'Beginner',
      component: Beginner,
      meta: {
        title: 'Beginner'
      }
    },{
      path: '/BeginnerDetail',
      name: 'BeginnerDetail',
      component: BeginnerDetail,
      meta: {
        title: 'BeginnerDetail'
      }
    },{
      path: '/Intermediate',
      name: 'Intermediate',
      component: Intermediate,
      meta: {
        title: 'Intermediate'
      }
    },{
      path: '/IntermediateDetail',
      name: 'IntermediateDetail',
      component: IntermediateDetail,
      meta: {
        title: 'IntermediateDetail'
      }
    },{
      path: '/Advanced',
      name: 'Advanced',
      component: Advanced,
      meta: {
        title: 'Advanced'
      }
    },{
      path: '/AdvancedDetail',
      name: 'AdvancedDetail',
      component: AdvancedDetail,
      meta: {
        title: 'AdvancedDetail'
      }
    },{
      path: '/Challenge',
      name: 'Challenge',
      component: Challenge,
      meta: {
        title: 'Challenge'
      }
    },{
      path: '/ChallengeLearn',
      name: 'ChallengeLearn',
      component: ChallengeLearn,
      meta: {
        title: 'ChallengeLearn'
      }
    },{
      path: '/ChallengeResult',
      name: 'ChallengeResult',
      component: ChallengeResult,
      meta: {
        title: 'ChallengeResult'
      }
    },{
      path: '/Sentences300',
      name: 'Sentences300',
      component: Sentences300,
      meta: {
        title: 'Sentences300'
      }
    },{
      path: '/Sentences300Detail',
      name: 'Sentences300Detail',
      component: Sentences300Detail,
      meta: {
        title: 'Sentences300Detail'
      }
    },
    {
		path: '/login',
		name: 'login',
		component: Login,
		meta: {
			title: 'Login'
		}
    },
    {
		path: '/otp',
		name: 'otp',
		component: otp,
		meta: {
			title: 'otp'
		}
    },
    {
		path: '/land',
		name: 'land',
		component: land,
		meta: {
			title: 'land'
		}
    },{
		path: '/myAccount',
		name: 'myAccount',
		component: MyAccount,
		meta: {
			title: ''
		}
    },{
		path: '/faq',
		name: 'faq',
		component: Faq,
		meta: {
			title: 'faqs'
		}
    },{
		path: '/termsAndCondition',
		name: 'termsAndCondition',
		component: TermsAndCondition,
		meta: {
			title: 'Terms and Condition'
		}
    },{
      path: '/guidance',
      name: 'guidance',
      component: guidance,
      meta: {
        title: 'guidance'
      }
    },

    {
      path: '/level',
      name: 'level',
      component: Level,
      meta: {
        title: 'level'
      }
    },
    {
      path: '/leveltest',
      name: 'leveltest',
      component: LevelTest,
      meta: {
        title: 'leveltest'
      }
    },
    {
      path: '/book',
      name: 'book',
      component: Book,
      meta: {
        title: 'book'
      }
    },
    {
      path: '/BookDetail',
      name: 'BookDetail',
      component: BookDetail,
      meta: {
        title: 'BookDetail'
      }
    },
    {
      path: '/BookDetail2',
      name: 'BookDetail2',
      component: BookDetail2,
      meta: {
        title: 'BookDetail2'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js